<template>
  <img
    :src="active ? $options.colored : $options.grey"
    class="checkpoint-circle"
    width="52px"
    height="52px"
  />
</template>
<script>
export default {
  colored: require("../../../../../assets/images/icons/alex/checkpoint.png"),
  grey: require("../../../../../assets/images/icons/alex/checkpoint_grey.png"),
  name: "CheckpointCircle",
  props: {
    active: {
      type: Boolean,
      defaullt: false,
    },
  },
};
</script>
<style scoped>
</style>
